import { alpha } from '@mui/material/styles';

export const testHistoryToolbarStyles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 2,
    mb: 2,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'flex-start', sm: 'flex-end' },
    flexWrap: 'wrap',
    gap: 1.5,
    width: { xs: '100%', md: 'auto' },
    '& .MuiButton-root': {
      minHeight: 40,
    },
  },
  aiButton: {
    borderColor: (theme) => alpha(theme.palette.secondary.main, 0.65),
    bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.08),
    color: 'secondary.main',
    borderRadius: 1,
    fontWeight: 700,
    px: 1.75,
    whiteSpace: 'nowrap',
    textTransform: 'none',
    '&:hover': {
      borderColor: 'secondary.main',
      bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.14),
    },
  },
};

export const testHistorySortSelectStyles = {
  formControl: {
    minWidth: 200,
    bgcolor: 'background.paper',
    borderRadius: 1,
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'primary.main',
      },
    },
  },
};

export const testHistoryStateStyles = {
  errorContainer: {
    mt: 3,
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 400,
    textAlign: 'center',
    color: 'text.secondary',
  },
  emptyIcon: {
    fontSize: 80,
    mb: 2,
    opacity: 0.5,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 400,
  },
  loadingProgress: {
    color: 'secondary.main',
  },
};
